import { Grid2, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import UncontrolledSearchSelect from "../../../components/UncontrolledSearchSelect";
import { notifyError, notifySuccess } from "../../../utilities/helper";
import CapsTableComponent from "../../../components/CapsTableComponent/CapsTableComponent";
import { addCountryCapService } from "../../../services/studyCapsService";
import { useNavigate } from "react-router-dom";

const CountryCaps = ({
  statusData,
  countryData,
  onLoadData,
  userId,
  globalDateFormat,
  setLoad,
  rowData,
  access_token,
}) => {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");

  useEffect(() => {
    if (rowData && rowData.length > 0) {
      setRows([...rowData]);
    }
  }, [rowData]);

  const isCombinationExists = rows?.some(
    (item) =>
      item.patientStatusTypeId === selectedStatus &&
      item.countryId === selectedCountry,
  );
  const isAddCapDisabled =
    selectedStatus === "" || selectedCountry === "" || isCombinationExists;

  const addRow = async () => {
    if (selectedStatus !== "" && selectedCountry !== "") {
      const data = {
        countryId: selectedCountry,
        patientStatusTypeId: selectedStatus,
        userId: userId,
        globalDateFormat: globalDateFormat,
      };
      try {
        setLoad(true);
        const res = await addCountryCapService(access_token, data);
        if (
          res?.data?.message === "Country Cap added successfully!" &&
          res?.status == "200"
        ) {
          notifySuccess("Cap added successfully!");
          onLoadData("country");
        }
      } catch (err) {
        console.log("Error : ", err);
        notifyError(err?.message || "Something went wrong!");
        if (err?.status === 401) {
          navigate("/unAuthorize");
        }
      } finally {
        setSelectedStatus("");
        setSelectedCountry("");
        setLoad(false);
      }
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          gap: "30px",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "start",
        }}
      >
        <CapsTableComponent
          isFullScreen={false}
          rows={rows}
          setRows={setRows}
          isNotStatusCap={true}
          dynamicColName={"country"}
          tabValue={"country"}
          getOnLoadData={onLoadData}
          setLoad={setLoad}
          columnValue="countryName"
        />
        <div
          style={{
            border: "1px solid lightgrey",
            borderRadius: "8px",
            padding: "10px",
            width: "40%",
          }}
        >
          <p className="page-heading">Add A New Country Cap</p>
          <Grid2
            container
            alignItems="center"
            justifyContent={"space-between"}
            gap={1}
          >
            <Grid2 size={{ xl: 12, md: 12, lg: 12, sm: 12, xs: 12 }}>
              <div>
                <p
                  className="labelStyles"
                  style={{
                    marginTop: "-10px",
                  }}
                >
                  Country
                </p>

                <UncontrolledSearchSelect
                  data={countryData}
                  optionLabel="name"
                  optionKey="id"
                  value={selectedCountry}
                  placeholder="Country"
                  onChange={(selectedValue) => {
                    setSelectedCountry(selectedValue);
                  }}
                />
              </div>
            </Grid2>
            <Grid2 size={{ xl: 12, md: 12, lg: 12, sm: 12, xs: 12 }}>
              <div>
                <p className="labelStyles">Status</p>

                <UncontrolledSearchSelect
                  data={statusData}
                  optionLabel="patientStatusDescription"
                  optionKey="id"
                  value={selectedStatus}
                  placeholder="Status"
                  onChange={(selectedValue) => {
                    setSelectedStatus(selectedValue);
                  }}
                />
              </div>
            </Grid2>
          </Grid2>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "20px",
            }}
          >
            <Tooltip
              slotProps={{
                tooltip: {
                  sx: {
                    fontSize: "14px",
                    padding: "8px 12px",
                  },
                },
              }}
              title={
                selectedStatus === "" || selectedCountry === ""
                  ? "Select country and status"
                  : isCombinationExists
                    ? "Cap already exists for this Country and Status"
                    : "Add Cap"
              }
            >
              <span>
                <button
                  className={!isAddCapDisabled ? "create-btn" : "disabled-btn"}
                  disabled={isAddCapDisabled}
                  onClick={addRow}
                >
                  Add Cap
                </button>
              </span>
            </Tooltip>
          </div>
        </div>
      </div>
    </>
  );
};

export default CountryCaps;
